import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// import VinForm from 'shared/components/LeasingAndVin/VinForm';
import SocialLinks from 'shared/components/SocialLinks/SocialLinks';
import s from './AdvertInfo.css';

class AdvertInfo extends React.Component {
  static propTypes = {
    infoList: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
      }),
    ),
    advert: PropTypes.shape(),
  };
  static defaultProps = {
    infoList: [],
    advert: {},
  };

  render() {
    const { infoList, advert } = this.props;

    return (
      infoList.length > 0 &&
      <div className={s.root}>
        {infoList.map(item =>
          <div className={s.row} key={`${item.title}-${item.value}`}>
            <div className={s.col}>
              {item.title}
            </div>
            <div className={s.colAuto}>
              <span className={s[item.decorationClassName]}>
                {item.value}
              </span>
            </div>
          </div>,
        )}
        {advert.posted_in_social && <SocialLinks advert={advert} />}
        {/* <Row type="flex" justify="start">
          <div className={s.LeasingFormStyle}>
            <VinForm advert={advert} />
          </div>
        </Row> */}
      </div>
    );
  }
}

export default withStyles(s)(AdvertInfo);



// WEBPACK FOOTER //
// ./src/desktop/components/AdvertInfo_Old/AdvertInfo.js